import Vue, {PluginFunction} from "vue"
import App from "@/pages/App.vue"
import router from "@/router"
import "@/semantic-theme/semantic.less"
import store from "@/store"
import ToastedPlugin from "vue-toasted"
import {appConfig} from "@/config/app.config"
import Tracker from "@/services/tracking.service"

Vue.config.productionTip = appConfig.IS_TARGETING_PRODUCTION

Tracker.init()

const Toasted = ToastedPlugin as unknown as PluginFunction<object>
Vue.use(Toasted, {
    position: "bottom-right", iconPack: "custom-class", action: {
        text: "Close",
        onClick: (_: Event, toastObject: { goAway: (delay?: number) => void }) => toastObject.goAway(0),
    },
})

new Vue({
    router,
    store,
    render: (h) => h(App),
})
    .$mount("#app")
